import React from 'react';
import ChallengesContainer from './ChallengeContainer';
import Challenge from './Challenge';
import FIRST_CHALLENGE from '../../resources/images/T1.svg';
import SECOND_CHALLENGE from '../../resources/images/T2.svg';
import THIRD_CHALLENGE from '../../resources/images/T3.svg';
import FOURTH_CHALLENGE from '../../resources/images/T4.svg';

export default (props) => {
    var {lang, handleChallengeClick} = props;
    return <ChallengesContainer title={lang.tasks_header_label}>
        <Challenge name="T1" header={lang.form_container.T1_header} subheader_1={lang.form_container.T1_subheader_1} subheader_2={lang.form_container.T1_subheader_2} image={FIRST_CHALLENGE} handleChallengeClick={handleChallengeClick} />
        <Challenge name="T2" header={lang.form_container.T2_header} subheader_1={lang.form_container.T2_subheader_1} subheader_2={lang.form_container.T2_subheader_2}  image={SECOND_CHALLENGE} handleChallengeClick={handleChallengeClick} />
        <Challenge name="T3" header={lang.form_container.T3_header} subheader_1={lang.form_container.T3_subheader_1} subheader_2={lang.form_container.T3_subheader_2}  image={THIRD_CHALLENGE} handleChallengeClick={handleChallengeClick} />
        <Challenge name="T4" header={lang.form_container.T4_header} subheader_1={lang.form_container.T4_subheader_1} subheader_2={lang.form_container.T4_subheader_2}  image={FOURTH_CHALLENGE} handleChallengeClick={handleChallengeClick} />
    </ChallengesContainer>
}


// WEBPACK FOOTER //
// ./src/components/challenges/index.jsx